<template>
  <div class="px-3" v-resize="onResize">
    <v-row class="px-3">
      <v-col cols="12" md="8" class="pl-0">
        <h1 class="py-md-3">
          {{ $t("viewCalls.title") }}
        </h1>
      </v-col>
      <v-col cols="12" md="4" align-self="end" class="d-flex justify-end px-0">
        <v-text-field
          outlined
          :placeholder="$t('viewCustomers.search_placeholder')"
          append-icon="fa-times"
          hide-details
          @click:append="search = ''"
          v-model="search"
          class="mb-2 text-field-bg d-none"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-data-table
      :height="tableHeight"
      ref="callsTable"
      :headers="callsTableHeader"
      :items="calls"
      class="elevation-0 mb-3"
      :loading="!fetched"
      :footer-props="{
        'items-per-page-text': $t('tables.items_per_page'),
        'items-per-page-options': [
          50, 100,
          //-1
        ],
      }"
    >
      <template v-slot:footer.page-text="props">
        {{
          $t("tables.x_of_y", [
            `${props.pageStart}-${props.pageStop}`,
            props.itemsLength,
          ])
        }}
      </template>
      <template v-slot:item="props">
        <tr>
          <td class="text-xs-left">
            {{ props.item.created_at | moment("DD.MM.YYYY") }}
            <br/>
            {{ props.item.created_at | moment("HH:mm") }}
          </td>
          <td class="text-xs-left">
            <span v-if="props.item.call_direction">
              <v-icon v-if="props.item.call_direction === 1" color="success">
                mdi-call-received
              </v-icon>
              <v-icon v-if="props.item.call_direction === 2" color="danger">
                mdi-call-made
              </v-icon>
              <v-icon v-if="props.item.call_direction === 0">
                mdi-swap-vertical-variant
              </v-icon>
            </span>
            {{ props.item.phone }}
          </td>
          <td class="text-xs-left">{{ props.item.length_sec }}</td>
          <td class="text-xs-left">
            <span v-if="props.item.customer">
              {{ props.item.customer.full_name }}
              {{
                props.item.customer.is_company == 1
                  ? "[" + props.item.customer.legal_name + "]"
                  : ""
              }}
            </span>
          </td>
          <td
            class="text-right text-no-wrap vertical_align_center"
            style="min-width: 280px"
          >
            <div class="d-inline-block callRecPlayer"
                 v-if="                  !!records.find(
                    (rec) => rec.callId === props.item.id && rec.isFetching===false
                  )"
            >
              <vue-plyr
                :key="props.item.recording_id"
                :download="
                  records.find(
                    (rec) => rec.callId === props.item.id && rec.file
                  ).file
                "
                v-if="
                  props.item.recording_id &&
                  records.find(
                    (rec) =>
                      rec.callId === props.item.id &&
                      rec.file &&
                      !rec.isFetching
                  )
                "
              >
                <audio controls crossorigin playsinline>
                  <source
                    :src="
                      records.find(
                        (rec) => rec.callId === props.item.id && rec.file
                      ).file
                    "
                    type="audio/mp3"
                  />
                </audio>
              </vue-plyr>
            </div>
          </td>
          <td class="text-right text-no-wrap" style="min-width: 80px">
            <span class="btn-td-wrap">
              <v-btn
                  elevation="0"
                  min-width="36"
                  min-height="36"
                  color="green"
                  class="mb-0 ml-3 px-0 white--text"
                @click="getCallRecord(props.item)"
                :loading="
                  !!records.find(
                    (rec) => rec.callId === props.item.id && rec.isFetching
                  )
                "
                :disabled="
                !props.item.recording_id ||
                  !!records.find(
                    (rec) => rec.callId === props.item.id && rec.isFetching
                  )
                "
              >
                <v-icon small>mdi-headphones</v-icon>
              </v-btn>
              <v-btn
                elevation="0"
                min-width="36"
                min-height="36"
                @click="$store.dispatch('calls/remove', { id: props.item.id })"
                color="red lighten-2"
                class="mb-0 ml-3 px-0 white--text"
                :title="$t('common.remove')"
              >
                <v-icon small>$trash</v-icon>
              </v-btn>
            </span>
          </td>
        </tr>
      </template>
      <template v-slot:no-data>
        {{ $t("common.no_data_available") }}
      </template>
      <template v-slot:no-results>
        {{ $t("common.no_data_available") }}
      </template>
      <template v-slot:no-data>
        {{ $t("common.no_data_available") }}
      </template>
      <template v-slot:no-results>
        {{ $t("common.no_data_available") }}
      </template>
      <template v-slot:loading>
        {{ $t("common.loading") }}
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
import CustomerForm from "@/components/customer/CustomerForm.vue";
import CommonMixin from "@/mixins/common";

export default {
  data: () => ({
    search: "",
    tableHeight: "100",
  }),
  mixins: [CommonMixin],
  components: {},
  mounted() {
    this.$store.dispatch("calls/get");
  },
  computed: {
    ...mapFields("calls", [
      "calls",
      "fetched",
      "isCallRecordFetching",
      "records",
    ]),
    callsTableHeader() {
      return [
        {
          text: this.$t("common.created_at"),
          value: "created_at",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.phone"),
          value: "phone",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("viewCalls.length_sec"),
          value: "length_sec",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.first_name"),
          value: "last_name",
          sortable: true,
          class: "text-no-wrap",
        },
        { text: "", sortable: false, class: "text-no-wrap" },
      ];
    },
  },
  methods: {
    getCallRecord(call) {
      this.$store.dispatch("calls/getCallRecord", call);
    },
    onResize() {
      this.setTableHeight();
    },
    setTableHeight() {
      let rect = this.$refs["callsTable"].$el.getBoundingClientRect();
      if (rect) {
        this.tableHeight = window.innerHeight - rect.top - 90;
      }
    },
  },
  watch: {
    fetched() {
      this.$nextTick(() => {
        this.setTableHeight();
      });
    },
  },
};
</script>
<style lang="css">
.callRecPlayer .plyr--audio .plyr__controls {
  background-color: transparent;
  z-index: 10000;
}
</style>
